import React, { ReactElement } from "react";

import { Card } from "primereact/card";

import styles from "./DataCard.module.css";

/**
 * Card component which could have any react component shown in the main body.
 * @param props
 * @returns
 */
export const DataCard = (props: {
    title: string;
    subTitle: string;
    icon: string;
    children?: React.ReactNode;
}): ReactElement => {
    return (
        <Card
            title={
                <div>
                    <i data-testid="datacard-icon" className={props.icon}></i>
                    <span className={styles.DataCardHeaderTitle}>
                        {props.title}
                    </span>
                </div>
            }
            subTitle={props.subTitle}
        >
            {props.children}
        </Card>
    );
};
